import request from "@/utils/request";
// 查询分组
export function getAllGroup(query) {
  return request({
    url: '/system/group/getGroup',
    method: 'get',
    params: query
  })
}
// 新增任务发布
export function addTask(data) {
  return request({
    url: '/system/task',
    method: 'post',
    data: data
  })
}

// 修改任务发布
export function updateTask(data) {
  return request({
    url: '/system/task',
    method: 'post',
    data: data
  })
}
// 查询任务发布详细
export function getTask(id) {
  return request({
    url: '/system/task/' + id,
    method: 'get'
  })
}